import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { map, sortBy, filter, forEach } from "lodash";

import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";
import {array_utilities} from "../../Atollon/utilities/array_utilities";
import {TouchTable, TouchTable_alignColumnRight} from "../../AtollonTheme/ReactElements";
import { isAdmin } from "../../utils";
import { canUserEditThisOrganization } from "../../Atollon/CanUserEditThisOrganization";
import {administeredCssColor, ownedCssColor, relatedCssColor} from "../../Atollon/Instance/InstanceRoles/InstanceRoleColor";
import * as InstanceRoles from "../../Atollon/Instance/InstanceRoles";
import {getDesktopClientUrl, getUrlToOpenInstanceInNewWindow} from "../../constants";

const Table = (state) => {

    let { history, userOrganizations_byType, myAtollon_selectedUserOrganizationTypeName, searchBar, role } = state;

    // console.log('%cstate', 'color:#fff;background:#000', state);
    const userOrganizations =  userOrganizations_byType[myAtollon_selectedUserOrganizationTypeName];
    let sortedInstances = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( userOrganizations, ['name'] );
    let filteredInstances = filter( sortedInstances, (instance) => {

            if( searchBar.searchText )
            {
                let matches = ( string ) => {
                    return string.toLocaleLowerCase().match( searchBar.searchText.toLocaleLowerCase() );
                };
                let match = matches( instance.ident ) || matches( instance.name );
                return match;
            }
            else
            {
                return true;
            }
    });

    {
        // let usersWhoCanEditInstance = state && state.canUserEditThisOrganization && state.canUserEditThisOrganization.usersWhoCanEditInstance ;
        // console.log( { usersWhoCanEditInstance: usersWhoCanEditInstance });
    }

    const MyInstanceRolesIndication = InstanceRoles.InstanceRolesIndication;

        return (
        <div>
            <TouchTable
                headerAsList={["Jméno", "Identifikátor", TouchTable_alignColumnRight( "Akce" )]}
                elementsAsList={
                    map( filteredInstances, (instance, i) => {
                        return ([
                            <MyInstanceRolesIndication instanceUuid={instance.id} state={state._state}>
                                {instance.name}
                            </MyInstanceRolesIndication>,
                            instance.ident,
                            (
                                <div>

                                    {/*  style={{width: '100%', textAlign: 'right'}} */}

                                    {canUserEditThisOrganization( state._state, instance )?
                                        <Button flat
                                                primary
                                                label="Upravit"
                                                className="btn btn-primary touchButton-3 touchButton-shape3"
                                                onClick={(event) => {

                                                    // do not
                                                    event.preventDefault();

                                                    history.push(`/organizations/${instance.id}`);
                                                }}
                                        />
                                        :
                                        <div/>
                                    }

                                    <div style={{display: 'inline-block', position: 'relative', margin: '0 0 0 5px'}}>

                                        <Button flat
                                                primary
                                                label="Web"
                                                className="btn btn-primary touchButton-6"
                                        />

                                        <a
                                            href={getUrlToOpenInstanceInNewWindow(instance)}
                                            target="_blank" style={

                                            // CSS: whole card is clickable
                                            {
                                                textDecoration: 'none',
                                                position: 'absolute',
                                                width: '100%',
                                                height: '100%',
                                                background: 'red',
                                                opacity: 0,
                                                left: 0,
                                                top: 0,
                                                zIndex: 1
                                            }}
                                        />
                                    </div>

                                    <div style={{display: 'inline-block', position: 'relative', margin: '0 0 0 5px'}}>

                                        <Button flat
                                                primary
                                                label="Desktop"
                                                className="btn btn-primary touchButton-6"
                                        />

                                        <a
                                            href={getDesktopClientUrl(instance)}
                                            target="_blank" style={

                                            // CSS: whole card is clickable
                                            {
                                                textDecoration: 'none',
                                                position: 'absolute',
                                                width: '100%',
                                                height: '100%',
                                                background: 'red',
                                                opacity: 0,
                                                left: 0,
                                                top: 0,
                                                zIndex: 1
                                            }}
                                        />
                                    </div>

                                </div>
                            )
                        ]);
                    })
                }
            />
        </div>
  );
};

export default compose(
  connect(
    (state) => {
        let {
            app: { role },
            resource: { userOrganizations_byType, myAtollon_selectedUserOrganizationTypeName }, searchBar } = state;
        return (
            {
                role,
                userOrganizations_byType,
                myAtollon_selectedUserOrganizationTypeName,
                searchBar,
                _state: state
            }
        );
    },
    null
  )
)(Table);



// WEBPACK FOOTER //
// ./src/components/organizations/Table.js